<template>
  <div
    id="no-result-found"
    class="no-result"
    :class="isErrorMessage ? 'no-result--error-message' : ''"
  >
    <svgicon
      :name="
        isErrorMessage ? 'Alerts/Warning_illustrative' : 'Search/Search'
      "
      class="no-result__icon-search"
      :original="true"
    />
    <div class="no-result__text">
      <h3 v-text="isErrorMessage ? errorHeading : infoHeading" />
      <p v-text="isErrorMessage ? errorMessage : infoMessage" />
    </div>
  </div>
</template>

<script>
  import "#/Alerts/Warning_illustrative"
  import "#/Search/Search"

  export default {
    name: "SearchNotification",
    props: {
      isErrorMessage: {
        type: Boolean,
        default: false
      },
      heading: {
        type: String,
        default: ""
      },
      message: {
        type: String,
        default: ""
      }
    },
    data () {
      return {
        errorHeading: this.heading ? this.heading : "Oops, tekniskt fel",
        errorMessage: this.message ? this.message : "Vi upplever just nu tekniska problem. Vänligen testa att söka igen!",
        infoHeading: this.heading ? this.heading : "Din sökning gav inget resultat",
        infoMessage: this.message ? this.message : "Kontrollera att orden är rättstavade eller testa med andra sökord."
      }
    },
  }
</script>

<style lang="scss">
  .no-result {
    padding: 1rem;
    background-color: $color-blue-lightest;
    display: flex;
    align-items: flex-start;
    border-radius: 0.25rem;

    &--error-message {
      background-color: $color-red-special;
      color: $color-red-dark;
    }

    @include media-breakpoint-up(md) {
      align-items: center;
      padding: 1.5rem;
    }

    h3 {
      @include font(rubrik, 1, "bold");

      margin: 0 0 0.5rem;

      @include media-breakpoint-up(md) {
        @include font(rubrik, 2, "bold");

        margin: 0;
      }
    }

    p {
      margin: 0;
      white-space: normal;

      @include font(text, 3, "normal");
    }

    &__icon-search {
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;

      @include media-breakpoint-up(md) {
        width: 2.5rem;
        height: 2.5rem;
      }
    }

    &__text {
      display: inline-flex;
      flex-direction: column;
      margin-left: 1rem;
    }
  }
</style>
